(function(window, angular, undefined) {

/**
 * Enables analytics support for Google Analytics (http://google.com/analytics)
 * via Global Site Tag.
 */
angular.module('angulartics.google.gtag', ['angulartics'])
.config(['$analyticsProvider', '$windowProvider', function ($analyticsProvider, $windowProvider) {

  var $window = $windowProvider.$get();

  // GA already supports buffered invocations so we don't need
  // to wrap these inside angulartics.waitForVendorApi
  $analyticsProvider.settings.pageTracking.trackRelativePath = true;

  // We cache the latest pageTrack path value here to ensure consistent
  // tracking of the page dimension with other hits
  var pagePathCache;

  // Set the default settings for this module
  $analyticsProvider.settings.ga = {
    additionalAccountNames: undefined,
    // Select hits to send to all additional accounts
    additionalAccountHitTypes: {
      pageview: true,
      event: true,
      exception: false,
      ecommerce: false,
      userTiming: false,
      setUserProperties: false,
      userId: false
    },
    disableEventTracking: null,
    disablePageTracking: null,
    enhancedEcommerce: false,
    // GA supports transporting data via gif requests, XHRs, or sendBeacons
    // @link https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#transport
    transport: null,
    userId: null
  };

  /**
   * Track Pageview in GA
   * @name pageTrack
   *
   * @param {string} path value of Page dimension stored with hit e.g. '/home'
   * @param {object} properties Object with optional addtional Custom Dimensions/Metrics
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
   * @link https://developers.google.com/analytics/devguides/collection/gajs/
   */
  $analyticsProvider.registerPageTrack(function (path, properties) {
    pagePathCache = path;

    properties = properties || {};

    // Do nothing if page tracking is disabled
    if ($analyticsProvider.settings.ga.disablePageTracking) return;

    dispatchToGtag('event', 'page_view', angular.extend(angular.copy(properties), {
      page: path
    }));
  });

  /**
   * Track Event in GA
   * @name eventTrack
   *
   * @param {string} action Required 'action' (string) associated with the event
   * @param {object} properties Comprised of the mandatory field 'category' (string) and optional  fields 'label' (string), 'value' (integer) and 'nonInteraction' (boolean)
   *
   * @link https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide#SettingUpEventTracking
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  $analyticsProvider.registerEventTrack(function(action, properties) {

    // Do nothing if event tracking is disabled
    if ($analyticsProvider.settings.ga.disableEventTracking) return;

    if (!action && action + '' !== '0') {
      return;
    }

    // Sets default properties
    properties = properties || {};
    properties.category = properties.category || 'Event';

    // GA requires that eventValue be an integer, see:
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#eventValue
    // https://github.com/luisfarzati/angulartics/issues/81
    if (properties.value) {
      var parsed = parseInt(properties.value, 10);
      properties.value = isNaN(parsed) ? 0 : parsed;
    }

    // GA requires that hitCallback be an function, see:
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits#hitcallback
    if (!angular.isFunction(properties.hitCallback)) {
      properties.hitCallback = null;
    }

    // Making nonInteraction parameter more intuitive, includes backwards compatibilty
    // https://github.com/angulartics/angulartics-google-analytics/issues/49
    properties.nonInteraction = properties.nonInteraction || properties.noninteraction;

    dispatchToGtag('event', action, angular.extend(angular.copy(properties), {
      eventCategory: properties.category,
      eventLabel: properties.label,
      value: properties.value,
      nonInteraction: properties.nonInteraction == true,
    }));
  });

  /**
   * Exception Track Event in GA
   * @name exceptionTrack
   * Sugar on top of the eventTrack method for easily handling errors
   *
   * @param {object} error An Error object to track: error.toString() used for event 'action', error.stack used for event 'label'.
   * @param {object} cause The cause of the error given from $exceptionHandler, not used.
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/events
   */
  // $analyticsProvider.registerExceptionTrack(function (error, cause) {
  //   var action = error.toString();
  //   dispatchToGtag('event', action, {
  //     eventCategory: 'Exceptions',
  //     eventLabel: error.stack,
  //     nonInteraction: true,
  //     page: getPage_({}),
  //     isException: true
  //   });
  // });

  /**
   * Set Username
   * @name setUsername
   *
   * @param {string} userId Registers User ID of user for use with other hits
   *
   * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#user_id
   */
  $analyticsProvider.registerSetUsername(function (userId) {
    $analyticsProvider.settings.ga.userId = userId;

    var properties = $analyticsProvider.settings.tagPropertyIds;
    for (let i = 0; i < properties.length; i++) {
      var id = properties[i];
      // @ts-ignore
      gtag('config', id, {
        'user_id': userId,
      });
    }
  });

  /**
   * Extract Custom Data for a hit
   * @name dimensionsAndMetrics
   *
   * @param {object} properties properties object from an API call that is filtered for Custom Dimensions & Metrics
   *
   * @returns {object} customData object with only Custom Dimensions/Metrics from properties argument
   */
  function dimensionsAndMetrics(properties) {
    // add custom dimensions and metrics
    var customData = {};
    var key;

    for (key in properties) {
      // Keys must be dimensionXX or metricXX, e.g. dimension1, metric155, so
      // if those strings aren't at zero (which evaluates to falsey), ignore
      // the key
      if (!key.indexOf('dimension') || !key.indexOf('metric')) {
        customData[key] = properties[key];
      }
    }
    return customData;
  }

  /**
   * Handler for hits to GA. Dynamically adjusts syntax for
   * targeted version based on global detection.
   *
   * @name dispatchToGa
   *
   * @param {string} command Standard Universal Analytics command (create, send, set)
   * @param {string} action name of action
   * @param {object} fieldsObj object with hit-specific fields. Fields are whitelisted in handler - non-supported fields are ignored.
   *
   */
  var dispatchToGtag = function(command, action, fieldsObj) {
    var params = {};
    if ($analyticsProvider.settings.ga.transport) {
      params.transport = $analyticsProvider.settings.ga.transport;
    }

    if ($analyticsProvider.settings.ga.userId) {
      params.user_id = $analyticsProvider.settings.ga.userId;
    }

    var commandArray;

    if (command == 'event' && action == 'page_view') {
      commandArray = [
        command,
        action,
        angular.merge(params, {
          page_title: fieldsObj.pageTitle,
          page_location: fieldsObj.location,
          page_path: fieldsObj.path
        })
      ]
    } else if (command == 'event') {
      commandArray = [
        command,
        action,
        angular.merge(params, {
          event_category: fieldsObj.eventCategory,
          event_label: fieldsObj.eventLabel,
          value: fieldsObj.value
        })
      ];
    }

    if ($window['gtag'] && !!commandArray) {
      // Perform our initial call
      $window['gtag'].apply(this, commandArray);
    }
  }



  /**
   * Helper function for getting page value
   *
   * @param {Object} properties
   *
   * @returns {String}
   */
  function getPage_(properties) {

    return properties.page || pagePathCache ||
      $window.location.hash.substring(1) || window.location.pathname;

  }

}]);
})(window, window.angular);